<template>
  <VTooltip
    v-if="hasContent()"
    :triggers="['hover', 'click']"
    :popper-triggers="['hover', 'click']"
    :auto-hide="true"
  >
    <HelpIcon color="light-grey" />
    <template #popper>
      <div
        style="max-width: 240px"
        v-html="content || $slots.default[0].text"
      />
    </template>
  </VTooltip>
</template>

<script>
import HelpIcon from "../../components/icons/HelpIcon";

export default {
  components: {
    HelpIcon,
  },
  props: ["content"],
  methods: {
    hasContent() {
      return (
        Boolean(this.$props.content) ||
        Boolean(this.$slots.default && this.$slots.default[0])
      );
    },
  },
};
</script>
